import {
  GRID_STATE_CHANGE,
  CLEAR_GRID
} from 'constants/actionTypes'

const INIT_STATE = {
  pageSize: 100,
  currentPage: 0,
  pageSizes: [100, 200],
  selection: [],
  sorting: [],
  hiddenColumnNames: []
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GRID_STATE_CHANGE:
      return {
        ...state,
        [action.partialStateName]: action.partialStateValue
      }
    case CLEAR_GRID:
      return {
        ...INIT_STATE
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./reducers/grid.js